var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { baseService } from './base.service';
const BASE_URL_API = (_a = process.env.REACT_APP_BASE_URL_API) !== null && _a !== void 0 ? _a : '';
const getCommercialProcessListById = (_a) => __awaiter(void 0, [_a], void 0, function* ({ id, idType, country, }) {
    const params = new URLSearchParams({
        documentId: id,
        documentType: idType.toUpperCase(),
        countryCode: country.toUpperCase(),
    });
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/process/applicable/business`, {
        params,
    });
    return response.data;
    // console.log(id, idType, country);
    // await wait(2000);
    // return GET_COMMERCIAL_PROCESSES_MOCK;
});
const getAllBanks = (country) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService
        .getServiceInstance()
        .get(`${BASE_URL_API}/api/rs-onboarding-gateway/cauth/banks/all`, {
        params: { country },
    });
    return response.data.banks.filter((b) => b.country_code === country);
});
const getAllowedCountries = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService.getServiceInstanceAuthorization().get(`${BASE_URL_API}/rests-manager-gateway/cauth/partners-selfservice/config-manager/settings/sob-menu-generator`);
    return response.data.settings;
});
const getCommercialProcesses = (_a) => __awaiter(void 0, [_a], void 0, function* ({ page, size, country, filters, }) {
    const params = new URLSearchParams({
        page: (page - 1).toString(),
        size: size.toString(),
        country: country.toUpperCase(),
        sort: 'updatedAt,desc',
    });
    if (filters.email)
        params.append('owner', filters.email);
    if (filters.processName)
        params.append('processName', filters.processName);
    if (filters.status)
        params.append('status', filters.status);
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/process/list/filtered`, {
        params,
    });
    return response.data;
});
const uploadDocument = (file, documentKey, country, scrapFile) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const formData = new FormData();
    formData.append('file', file);
    const fileTypeByKey = {
        BANK_ACCOUNT: 'BANK_ACCOUNT',
        SOCIAL_REASON: 'SOCIAL_REASON',
    };
    const params = {
        file_type: (_a = fileTypeByKey[documentKey]) !== null && _a !== void 0 ? _a : 'OTHER',
        scrap_file: scrapFile !== null && scrapFile !== void 0 ? scrapFile : false,
        country,
    };
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .post(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/files`, formData, {
        params,
    });
    return response.data;
});
const getCommercialProcessFileById = (id, name, extension) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/files/${id}`, {
        responseType: 'blob',
    });
    const blob = response.data;
    return new File([blob], `${name}${extension}`, { type: blob.type });
});
const getCommercialProcessContextById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield baseService
        .getServiceInstanceAuthorization()
        .get(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/process/context/${id}`);
    return response.data;
});
export const startCommercialProcess = (_a) => __awaiter(void 0, [_a], void 0, function* ({ commercialProcessId, businessId, body, }) {
    yield baseService
        .getServiceInstanceAuthorization()
        .post(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/process/start/${commercialProcessId}/business/${businessId}`, body);
});
export const updateCommercialProcess = (_a) => __awaiter(void 0, [_a], void 0, function* ({ commercialProcessContextId, body, }) {
    yield baseService
        .getServiceInstanceAuthorization()
        .post(`${BASE_URL_API}/rests-manager-gateway/cauth/api/rs-commercial-support/process/update/${commercialProcessContextId}`, body);
});
export const commercialProcessesService = {
    getCommercialProcessListById,
    getAllowedCountries,
    getAllBanks,
    getCommercialProcesses,
    uploadDocument,
    getCommercialProcessFileById,
    getCommercialProcessContextById,
    startCommercialProcess,
    updateCommercialProcess,
};
